import React from 'react';
import PropTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import './BottomBar.css';

const Container = posed.div({
  openDetail: {
    y: 50,
    x: 0,
    transition: {
      ease: 'easeInOut',
    },
  },
  enter: {
    y: 0,
    x: 0,
    transition: {
      ease: 'easeInOut',
    },
  },
  exit: {
    y: 100,
    x: 0,
    transition: {
      ease: 'easeOut',
    },
  },
});

export const BottomBar = ({ header, body, open, openDetail }) => (
  <PoseGroup>
    {open && (
      <Container
        key="bottom-bar"
        className="container bottom-bar"
        pose={openDetail ? 'openDetail' : 'enter'}
      >
        <div className="row">
          <div className="col-12">
            <div className="p-4 bg-white shadow-flash">
              {header}
              <div className="row d-none">{body}</div>
            </div>
          </div>
        </div>
      </Container>
    )}
  </PoseGroup>
);

BottomBar.propTypes = {
  header: PropTypes.object,
  body: PropTypes.object,
  open: PropTypes.bool,
  openDetail: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/BottomBar/BottomBar.js